import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class StrategyProxy extends ProxyBase {
  getRanking(params) {
    return this.get('GetRanking', params);
  }
  getAllScore(params) {
    return this.get('GetAllScore', params);
  }
  getAccumulation(params) {
    return this.get('GetAccumulation', params);
  }
  getRateIndicator(params) {
    return this.get('GetRateIndicator', params);
  }

  downloadAllScore(params) {
    return this.get('DownloadAllScore', params, null, 'download');
  }
  downloadRanking(params) {
    return this.get('DownloadRanking', params, null, 'download');
  }
  downloadIndicators(params) {
    return this.get('DownloadIndicators', params, null, 'download');
  }
}

const strategyProxy = new StrategyProxy(
  ServiceProxyConfig.Stategy.Ranking.ServiceUrl,
);
export default strategyProxy;
